import { gql } from "graphql-tag";

export const SIGN_IN_ATTEMPT = gql`
  mutation UserLoginPreflight($username: String!) {
    userLoginPreflight(username: $username) {
      login {
        username
        verified
        method
      }
    }
  }
`;

export const USER_LOGIN = gql`
  mutation UserLogin($username: String!, $password: String!) {
    userLogin(username: $username, password: $password) {
      success
      token
      userId
    }
  }
`;

export const USER_PHONE_LOGIN = gql`
  mutation UserPhoneLogin($username: String!, $code: String!) {
    userPhoneLogin(username: $username, code: $code) {
      success
      token
      userId
    }
  }
`;

export const USER_GET_CODE = gql`
  mutation UserGetCode($username: String!) {
    userGetCode(username: $username) {
      success
    }
  }
`;

export const CREATE_NEW_USER = gql`
  mutation CreateApplicantAccount($data: UserInput!) {
    createUser(data: $data) {
      id
    }
  }
`;

export const SEND_EMAIL_VERIFICATION = gql`
  mutation SendEmailVerification($email: String!, $redirectUrl: String!) {
    sendEmailVerification(email: $email, redirectUrl: $redirectUrl)
  }
`;

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($email: String!, $code: String!) {
    verifyEmail(email: $email, code: $code)
  }
`;
